import {
  Caption1,
  mergeClasses,
  SelectTabData,
  SelectTabEvent,
  Tab,
  TabList,
  TabValue,
} from '@fluentui/react-components';
import React from 'react';
import { useIntl } from 'react-intl';

import { Flex } from '@tdp/common/fluentV9MigrationComponents';
import {
  AnalyticsV2Interval,
  AnalyticsV2WidgetLoadingState,
  AnalyticsV2WidgetSize,
  analyticsV2ContainerStyles,
} from '@tdp/modules/apps';

import { AnalyticsContainer } from './AnalyticsContainer';

interface IMultiDataWidgetContainer {
  size: AnalyticsV2WidgetSize;
  header: string;
  loadingState: AnalyticsV2WidgetLoadingState;
  daily: React.ReactNode;
  weekly: React.ReactNode;
  monthly: React.ReactNode;
  isNew?: boolean;
}

export const MultiWidgetContainer: React.FC<IMultiDataWidgetContainer> = ({
  size,
  header,
  loadingState,
  daily,
  monthly,
  weekly,
  isNew,
}) => {
  const styles = analyticsV2ContainerStyles();
  const intl = useIntl();

  const [selectedValue, setSelectedValue] = React.useState<TabValue>(
    AnalyticsV2Interval.Monthly
  );

  const onTabSelect = (_: SelectTabEvent, data: SelectTabData) => {
    // Logger.LogUserBi(TelemetryObjectId.AnalyticsMultiWidgetTabSwitch, { message: header });
    setSelectedValue(data.value);
  };

  const dailyTitle = intl.formatMessage({
    defaultMessage: 'Daily (DAU)',
    description: 'Title for daily analytics widget',
  });

  const weeklyTitle = intl.formatMessage({
    defaultMessage: 'Weekly (WAU)',
    description: 'Title for weekly analytics widget',
  });

  const monthlyTitle = intl.formatMessage({
    defaultMessage: 'Monthly (MAU)',
    description: 'Title for monthly analytics widget',
  });

  const tabTitle = (title: string, active: boolean) => {
    return (
      <Caption1
        className={mergeClasses(active && styles.tabTitleActiveCaption)}
      >
        {title}
      </Caption1>
    );
  };

  const MultiWidgetContainer = () => (
    <>
      <div className={styles.tabs}>
        <TabList
          size="small"
          selectedValue={selectedValue}
          onTabSelect={onTabSelect}
        >
          <Tab value={AnalyticsV2Interval.Monthly}>
            {tabTitle(
              monthlyTitle,
              selectedValue === AnalyticsV2Interval.Monthly
            )}
          </Tab>
          <Tab value={AnalyticsV2Interval.Weekly}>
            {tabTitle(
              weeklyTitle,
              selectedValue === AnalyticsV2Interval.Weekly
            )}
          </Tab>
          <Tab value={AnalyticsV2Interval.Daily}>
            {tabTitle(dailyTitle, selectedValue === AnalyticsV2Interval.Daily)}
          </Tab>
        </TabList>
      </div>
      <Flex fill>
        {selectedValue === AnalyticsV2Interval.Monthly && monthly}
        {selectedValue === AnalyticsV2Interval.Weekly && weekly}
        {selectedValue === AnalyticsV2Interval.Daily && daily}
      </Flex>
    </>
  );

  return (
    <AnalyticsContainer
      status={loadingState}
      size={size}
      children={<MultiWidgetContainer />}
      header={header}
      isNew={isNew}
    />
  );
};
